import { Component, Input, Renderer2, ViewChild } from '@angular/core';
import { MastersCategoryModel } from '../../masters.model';
import { CommonService } from 'src/app/shared/services/common.service';
import { NgbActiveModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MastersService } from '../../masters.service';
import { AppDropdownComponent } from 'src/app/shared/common-components/app-dropdown/app-dropdown.component';
import { DatePickerComponent } from 'src/app/shared/common-components/date-picker/date-picker.component';

@Component({
  selector: 'app-create-category',
  templateUrl: './create-category.component.html',
  styleUrls: ['./create-category.component.scss']
})
export class CreateCategoryComponent extends CommonService {
  @Input() templateData:any = {}
  @Input() data:any
  mastersCategoryModel = new MastersCategoryModel();
  @ViewChild(AppDropdownComponent) appDropdownComponent:AppDropdownComponent;
  @ViewChild(DatePickerComponent) datePickerComponent:DatePickerComponent;

  constructor(
    public activeModal:NgbActiveModal, 
    public renderer: Renderer2, 
    public toaster: ToastrService, 
    public mastersService: MastersService, 
  ){ super(renderer);}
  ngAfterViewInit(): void {
    this.UpdateMastersCategory()
   }

  validateForm(): boolean {
  const model = this.mastersCategoryModel;

  if (!model.categoryName?.trim() || !String(model.countryId || '').trim()) {
    this.toaster.error("Please fill all the required fields");
    return false;
  }
  return true;
}

  insertUpdateMastersList(){
    if(!this.validateForm()){
      return;
    }
    this.mastersService.insertUpdateMastersCategory(this.mastersCategoryModel).subscribe((res)=>{
      if(res.isSuccess){
        console.log(res);
        this.toaster.success(res?.message);
        this.activeModal.close(true)
      }else{
        this.toaster.error(res?.message);
      }
    })
  }
  
  UpdateMastersCategory(){
    console.log();
    if(this.data?.rowData){
      let option = this.data?.templateData?.countryDropdown?.filter(x=>x?.id==this.data?.rowData?.countryId);
      this.appDropdownComponent?.selectOption(option[0])
      this.mastersCategoryModel = {...this.mastersCategoryModel, ...this.data?.rowData ,} ;
    }
  }

  reset(){
    this.appDropdownComponent.reset();
    this.mastersCategoryModel = new MastersCategoryModel();
  }
}
